import { z } from "zod";

export const TestPayload = z.string().transform((v) => {
  try {
    const parsed = JSON.parse(v);
    const result = z
      .object({
        device: z.string().optional(),
        project: z
          .object({
            id: z.number(),
            name: z.string(),
          })
          .optional(),
        test_case_data: z
          .object({
            public_id: z.string().optional(),
            description: z.string().optional(),
            tag: z.string().nullable().optional(),
            instruction: z.string().optional(),
            expected_result: z.string().nullish(),
            is_precondition: z.boolean().optional(),
          })
          .optional(),
        type: z.enum(["visual", "api"]).optional(),
      })
      .parse(parsed);

    return result;
  } catch (error) {
    console.error("Error parsing TestPayload:", error, { value: v });
    return null;
  }
});

/**
 * What the runner does to the app between two cases. `clear_data` wipes cache and data, so
 * every case starts from a clean install and signs in again — the default. `restart` keeps
 * the session, the only way to test an app whose sign-in cannot be repeated (a one-time code,
 * a paired device). `keep` touches nothing, for a suite written as one continuous journey.
 *
 * A suite carries one; a batch may override it, where `null` means its suites decide
 * (N7AIT-1159).
 */
export const AppResetMode = z.enum(["clear_data", "restart", "keep"]);
export type AppResetMode = z.infer<typeof AppResetMode>;

/**
 * The same three modes plus `inherit`, which is what a case says when it has no
 * opinion of its own and leaves the answer to its suite (or to the batch that
 * overrode the suite). Cases default to `inherit`, so only a case that was
 * deliberately set apart carries one of the other three (N7AIT-1182).
 */
export const CaseAppResetMode = z.enum(["inherit", ...AppResetMode.options]);
export type CaseAppResetMode = z.infer<typeof CaseAppResetMode>;
